export class CreditCard {
	billingName: string = '';
	billingFirstName: string = '';
	billingLastName: string = '';
	creditCardNumber: string = '';
	expirationDate: string = '';
	billingZipcode: string = '';
}
